<style lang="less">
    @import "../../../styles/table.less";
</style>
<template>
    <div class="search">
        <Row>

                <Card :title="title">
                    <Row>
                        <Table :loading="loading" border :columns="columns" :data="data" sortable="custom" @on-sort-change="changeSort" @on-selection-change="showSelect" ref="table"></Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>

        </Row>

        <feedback-drawer ref="feedbackdrawer"></feedback-drawer>
        <detail-drawer ref="detailDrawer"></detail-drawer>


    </div>
</template>

<script>
    import circleLoading from "../../my-components/circle-loading.vue";
    import {add,edit,delAll,list,get} from "@/api/feedback";
    import FeedbackDrawer from "./feedback-drawer";
    import detailDrawer from "./detail-drawer";

    export default {
        name: "feedback-manage",
        components: {
            FeedbackDrawer,
            circleLoading,
            detailDrawer
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                title:"留言管理",
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "createTime", // 默认排序字段
                    order: "desc", // 默认排序方式
                    studentName: "",
                    mobile: "",
                    startDate: "",
                    endDate: ""
                },
                selectDate: null, //选择日期绑定modal
                columns: [
                    /*{
                        type: "selection",
                        width: 60,
                        align: "center"
                    },*/
                    {
                        type: "index",
                        title: "序号",
                        width: 80,
                        align: "center"
                    },
                    {
                        title: "学员昵称",
                        key: "nickName",
                        align:"center",
                        width: 150,
                        sortable: true
                    },

                    {
                        title: "学员名字",
                        key: "userName",
                        align:"center",
                        width: 150,
                        sortable: true
                    },
                    {
                        title: "头像",
                        key: "avatar",
                        width: 80,
                        align: "center",
                        render: (h, params) => {
                            return h("Avatar", {
                                props: {
                                    src: params.row.avatar
                                }
                            });
                        }
                    },
                    {
                        title: "反馈时间",
                        key: "createTime",
                        width: 170,
                        align: "center"
                    },
                    {
                        title: "反馈内容",
                        key: "content",
                        width: 250,
                        align: "center"
                    },
                    {
                        title: "反馈状态",
                        key: "status",
                        width: 250,
                        align: "center",
                        render: (h, params) => {
                            let re = "";
                            if (params.row.status == 0) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "purple"
                                            }
                                        },
                                        "未处理"
                                    )
                                ]);
                            } else if (params.row.status == 1) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "green"
                                            }
                                        },
                                        "已处理"
                                    )
                                ]);
                            }
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        width: 200,
                        align: "center",
                        fixed: "right",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.detail(params.row);
                                            }
                                        }
                                    },
                                    "详情"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.remove(params.row);
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            init() {
                // this.getTreeData();
                this.getDataList();
            },
            getDataList() {
                this.loading = true;
                list(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            showSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
            add() {
                let query = {type: 0}
                this.$refs.feedbackdrawer.showDrawer(query);
            },
            edit(row) {
                let query = { type: 1, id: row.id};
                this.$refs.feedbackdrawer.showDrawer(query);
            },
            detail(row){
                let query = { userId: row.userId, feedId: row.id};
                this.$refs.detailDrawer.showDrawer(query);
            },
            remove(row) {
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除?",
                    onOk: () => {
                        delAll(row.userId).then(res => {
                            if (res.status === true) {
                                this.$Message.success("删除成功");
                                this.getDataList();
                            }
                        });
                    }

                });
            },
            delAll() {

            }
        },
        mounted() {
            this.init();
        }
    }
</script>
